import {Exclude, Expose, instanceToPlain, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {Entity} from "./entity";

export const DVIRCustomFieldValueCodec = t.intersection([
  t.type({
    id: t.string,
    dvirId: t.string,
    customFieldProfileItemId: t.string,
    customFieldDefCode: t.string,
  }),
  t.partial({
    stringValue: t.string,
    numberValue: t.number,
    booleanValue: t.boolean,
    temporalValue: t.number,
    refObjectIdValue: t.string,
    refObjectType: t.string,
    createdById: t.string,
    lastModifiedById: t.string,
    createDttm: t.number,
    lastModifiedDttm: t.number,
    label: t.string,
  }),
]);

export type DVIRCustomFieldValue = t.TypeOf<typeof DVIRCustomFieldValueCodec>;

@Exclude()
export class DVIRCustomFieldValueEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  dvirId!: string;

  @Expose()
  customFieldProfileItemId!: string;

  @Expose()
  customFieldDefCode!: string;

  // ─────────────────────────────
  // Optional fields
  // ─────────────────────────────

  @Expose()
  stringValue?: string;

  @Expose()
  numberValue?: number;

  @Expose()
  booleanValue?: boolean;

  @Expose()
  temporalValue?: number;

  @Expose()
  refObjectIdValue?: string;

  @Expose()
  refObjectType?: string;

  @Expose()
  createdById?: string;

  @Expose()
  lastModifiedById?: string;

  @Expose()
  createDttm?: number;

  @Expose()
  lastModifiedDttm?: number;

  @Expose()
  label?: string;

  readonly entityType = "DVIRCUSTOMFIELDVALUE";

  get displayName(): Readonly<string> {
    return this.id;
  }

  /**
   * Constructor for DVIRCustomFieldValueEntity. Recommend using the {@link from} method instead.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: DVIRCustomFieldValue): DVIRCustomFieldValueEntity {
    return plainToInstance(DVIRCustomFieldValueEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<DVIRCustomFieldValue> {
    const object = instanceToPlain(this, {excludeExtraneousValues: true});
    return validateJSON(DVIRCustomFieldValueCodec, object);
  }

  asTypeValue(): DVIRCustomFieldValue {
    const object = instanceToPlain(this, {excludeExtraneousValues: true});
    return validateJSONNow(DVIRCustomFieldValueCodec, object);
  }
}
